import { Box } from '@mui/material';
import TicketsListTable from './TicketsListTable';

const TicketsList = () => {
	return (
		<Box className="mb-14 w-full">
			<TicketsListTable />
		</Box>
	);
};

export default TicketsList;
